import React from 'react';

const baseStyle = {
  height: '41px',
  width: '215px',
  border: 'none',
  textAlign: 'center',
  verticalAlign: 'center',
  boxShadow: '0 2px 4px 0 rgba(0,0,0,.25)',
  fontSize: '16px',
  lineHeight: '39px',
  display: 'block',
  borderRadius: '1px',
  transition: 'background-color .218s, border-color .218s, box-shadow .218s',
  fontFamily: 'Roboto,arial,sans-serif',
  cursor: 'pointer',
  userSelect: 'none',
} as React.CSSProperties;

export const darkStyle = {
  backgroundColor: '#4285f4',
  color: '#fff',
  ...baseStyle,
} as React.CSSProperties;

export const lightStyle = {
  backgroundColor: '#fff',
  color: 'rgba(0,0,0,.54)',
  ...baseStyle,
} as React.CSSProperties;

export const iconStyle = {
  width: '39px',
  height: '39px',
  textAlign: 'center',
  verticalAlign: 'center',
  display: 'block',
  marginTop: '1px',
  marginLeft: '1px',
  float: 'left',
  backgroundColor: '#fff',
  borderRadius: '1px',
  whiteSpace: 'nowrap',
} as React.CSSProperties;

export const svgStyle = {
  width: '39px',
  height: '39px',
  display: 'block',
} as React.CSSProperties;

export const hoverStyle = {
  boxShadow: '0 0 3px 3px rgba(66,133,244,.3)',
  transition: 'background-color .218s, border-color .218s, box-shadow .218s',
} as React.CSSProperties;

export const disabledStyle = {
  backgroundColor: 'rgba(37, 5, 5, .08)',
  color: 'rgba(0, 0, 0, .40)',
  cursor: 'not-allowed',
} as React.CSSProperties;

export const disabledIconStyle = {
  backgroundColor: 'transparent',
} as React.CSSProperties;
